import { useEffect, useState } from "react";
import OrtivisAvatarPreview from "./OrtivisAvatarPreview";

const skinColors = [
	"#FFDFC4", // Light
	"#F0C8A0", // Fair
	"#D19C6A", // Medium
	"#A36A4C", // Tan
	"#8D5524", // Dark
	"#5C4033", // Deep
];
const hairColors = [
	"#000000", // Black
	"#4A312C", // Dark Brown
	"#8B5A2B", // Light Brown
	"#D15F3F", // Ginger
	"#F4C27A", // Blonde
	"#D8D8D8", // Grey/White
];
const tshirtColors = [
	"#FF0000", // Red
	"#3498DB", // Blue
	"#F1C40F", // Yellow
	"#E67E22", // Orange
	"#2ECC71", // Green
	"#9B59B6", // Purple
];
const trousersColors = [
	"#000000", // Black
	"#8B5A2B", // Light Brown
	"#34495E", // Navy Blue
	"#BDC3C7", // Light Grey
	"#7F8C8D", // Dark Grey

	"#E74C3C", // Red
];

const OrtivisAvatarStep = ({ player, onAvatarChosen }) => {
	const [avatar, setAvatar] = useState({
		skin_color: "#F0C8A0",
		hair_shape: "cheveux_m",
		hair_color: "#000000",
		t_shirt_color: "#D15F3F",
		trousers_color: "#4A312C",
	});

	useEffect(() => {
		setAvatar(
			player?.avatar || {
				skin_color: "#F0C8A0",
				hair_shape: "cheveux_m",
				hair_color: "#000000",
				t_shirt_color: "#D15F3F",
				trousers_color: "#4A312C",
			}
		);
	}, [player]);

	const [activeTab, setActiveTab] = useState("appearance");

	useEffect(() => {
		if (player?.avatar) setAvatar(player.avatar);
	}, [player]);

	const updateAvatar = (field, value) => {
		setAvatar((prev) => ({ ...prev, [field]: value }));
	};

	useEffect(() => {
		onAvatarChosen(avatar);
	}, [avatar]);

	return (
		<div className="flex flex-col items-center w-full max-w-md">
			{/* Animated Avatar */}
			<div className="h-[140px] bg-blue-200 shadow-lg rounded-2xl flex items-center justify-center w-full max-w-[200px]">
				<OrtivisAvatarPreview avatar={avatar} />
			</div>

			<div className="w-full max-w-md p-4 bg-gray-100 shadow-lg rounded-2xl mt-4">
				{/* Tabs */}
				<div className="w-full max-w-md flex mb-2">
					<button
						onClick={() => setActiveTab("appearance")}
						className={`flex-1 py-1 px-2 rounded-s-full ${
							activeTab === "appearance" ? "bg-black text-white" : "bg-gray-300"
						}`}
					>
						Apparence
					</button>
					<button
						onClick={() => setActiveTab("clothes")}
						className={`flex-1 py-1 px-2 rounded-e-full ${
							activeTab === "clothes" ? "bg-black text-white" : "bg-gray-300"
						}`}
					>
						Vêtements
					</button>
				</div>
				<div className="flex flex-col text-sm">
					{activeTab === "appearance" ? (
						<>
							<div>Coiffure:</div>
							<div className="flex gap-4 mb-4">
								<button
									className={`flex-1 py-1 px-2 rounded-full ${
										avatar.hair_shape === "cheveux_m"
											? "bg-black text-white"
											: "bg-gray-300"
									}`}
									onClick={() => updateAvatar("hair_shape", "cheveux_m")}
								>
									Court
								</button>
								<button
									className={`flex-1 py-1 px-2 rounded-full ${
										avatar.hair_shape === "cheveux_f"
											? "bg-black text-white"
											: "bg-gray-300"
									}`}
									onClick={() => updateAvatar("hair_shape", "cheveux_f")}
								>
									Long
								</button>
							</div>

							<div>Couleur de peau:</div>
							<div className="grid grid-cols-6 gap-2 mb-4">
								{skinColors.map((color) => (
									<button
										key={color}
										className={`w-full h-10 rounded border ${
											avatar.skin_color === color
												? "border-black"
												: "border-gray-300"
										}`}
										style={{ backgroundColor: color }}
										onClick={() => updateAvatar("skin_color", color)}
									/>
								))}
							</div>

							<div>Couleur des cheveux:</div>
							<div className="grid grid-cols-6 gap-2 mb-4">
								{hairColors.map((color) => (
									<button
										key={color}
										className={`w-full h-10 rounded border ${
											avatar.hair_color === color
												? "border-black"
												: "border-gray-300"
										}`}
										style={{ backgroundColor: color }}
										onClick={() => updateAvatar("hair_color", color)}
									/>
								))}
							</div>
						</>
					) : (
						<>
							<div>Couleur du T-shirt:</div>
							<div className="grid grid-cols-6 gap-2 mb-4">
								{tshirtColors.map((color) => (
									<button
										key={color}
										className={`w-full h-10 rounded border ${
											avatar.t_shirt_color === color
												? "border-black"
												: "border-gray-300"
										}`}
										style={{ backgroundColor: color }}
										onClick={() => updateAvatar("t_shirt_color", color)}
									/>
								))}
							</div>

							<div>Couleur du Pantalon:</div>
							<div className="grid grid-cols-6 gap-2 mb-4">
								{trousersColors.map((color) => (
									<button
										key={color}
										className={`w-full h-10 rounded border ${
											avatar.trousers_color === color
												? "border-black"
												: "border-gray-300"
										}`}
										style={{ backgroundColor: color }}
										onClick={() => updateAvatar("trousers_color", color)}
									/>
								))}
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default OrtivisAvatarStep;
